import * as React from "react";
import type { SVGProps } from "react";
const SvgMicOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#mic-off_svg__a)">
      <path
        fill="currentColor"
        d="M1.707.293A1 1 0 0 0 .293 1.707zm20.586 23.414a1 1 0 0 0 1.414-1.414zM9 9l.707-.707A1 1 0 0 0 8 9zm0 3H8zm5.12 2.12.707.708a1 1 0 0 0 0-1.415zM14 9.34a1 1 0 1 0 2 0zM15 4l-1-.001V4zm-6.92-.799a1 1 0 0 0 1.96.398zm9.634 14.449a1 1 0 1 0-1.428-1.4zM5 12l1 .007V12zm1-2a1 1 0 1 0-2 0zm14 0a1 1 0 1 0-2 0zm-1 2h1zm-1.094 1.053a1 1 0 0 0 1.968.354zM13 19a1 1 0 1 0-2 0zm-2 4a1 1 0 1 0 2 0zm-3-1a1 1 0 1 0 0 2zm8 2a1 1 0 1 0 0-2zM.293 1.707l22 22 1.414-1.414-22-22zM8 9v3h2V9zm0 3a4 4 0 0 0 .675 2.221l1.663-1.112A2 2 0 0 1 10 12zm.675 2.221a4 4 0 0 0 1.795 1.472l.765-1.848a2 2 0 0 1-.897-.736zm1.795 1.472c.73.303 1.534.382 2.31.228l-.39-1.962a2 2 0 0 1-1.155-.114zm2.31.228a4 4 0 0 0 2.047-1.093l-1.414-1.415a2 2 0 0 1-1.023.546zm2.047-2.508-5.12-5.12-1.414 1.414 5.12 5.12zM16 9.34V4h-2v5.34zm0-5.339a4 4 0 0 0-1.031-2.685l-1.485 1.34A2 2 0 0 1 14 4zm-1.031-2.685A4 4 0 0 0 12.402.017l-.201 1.99a2 2 0 0 1 1.283.65zM12.402.017a4 4 0 0 0-2.774.76l1.186 1.61a2 2 0 0 1 1.387-.38zm-2.774.76A4 4 0 0 0 8.08 3.2l1.96.398a2 2 0 0 1 .774-1.212zm6.658 15.473a6 6 0 0 1-3.081 1.679l.401 1.96a8 8 0 0 0 4.108-2.24zm-3.081 1.679a6 6 0 0 1-3.493-.331l-.763 1.849a8 8 0 0 0 4.657.441zm-3.493-.331a6 6 0 0 1-2.71-2.228l-1.667 1.106a8 8 0 0 0 3.614 2.97zm-2.71-2.228A6 6 0 0 1 6 12.007l-2-.014a8 8 0 0 0 1.335 4.483zM6 12v-2H4v2zm12-2v2h2v-2zm0 2q0 .53-.094 1.053l1.968.354Q20 12.709 20 12zm-7 7v4h2v-4zm-3 5h8v-2H8z"
      />
    </g>
    <defs>
      <clipPath id="mic-off_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMicOff;
